import { Button, IconArrowDown, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { removeExcludedContentFromQuery } from 'utils/collection';

interface MoveManualArticleToQueryArticleProps {
  hierarchyId: string;
  jsonQueryStr: string;
  allessehContent: AllessehContent;
  setJsonQueryStr: (newQueryStr: string) => void;
  disabled?: boolean;
}

export const MoveManualArticleToQueryArticle = ({
  hierarchyId,
  jsonQueryStr,
  allessehContent,
  setJsonQueryStr,
  disabled = false
}: MoveManualArticleToQueryArticleProps) => {
  const { removeEntity } = useDataModelContext();

  const handleReinclude = () => {
    const parsedJsonQuery = removeExcludedContentFromQuery(allessehContent.data.id, jsonQueryStr);
    setJsonQueryStr(JSON.stringify(parsedJsonQuery));
  };

  const handleMove = () => {
    handleReinclude();
    removeEntity(hierarchyId);
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button tertiary icon={IconArrowDown} onClick={handleMove} disabled={disabled}>
          Remove from Top
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
